<template>
  <div>
    <Title :pages="[{ icon: 'fingerprint', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-card class="pa-4">

        <v-card class="pa-4" outlined>
          <h3 class="title font-weight-bold mb-3">Subir archivo de registros de fichadas</h3>
          <p>Seleccioná el archivo con los registros de fichadas para procesar y ver el listado de ingresos y egresos.</p>

          <v-row dense class="container-card" justify="center">
            <v-col cols="12" md="5">
              <div class="mb-4">
                <font-awesome-icon :icon="['fas', 'file']" class="me-2" />
                <v-label class="font-weight-bold ms-2"><strong>Archivo</strong></v-label>
              </div>

              <div class="card-file" @click="triggerFile">
                <font-awesome-icon :icon="['fas', 'arrow-up-from-bracket']" class="card-icon mb-2" />
                <template v-if="!file">
                  <p class="mb-0"><strong>Haga clic para seleccionar</strong></p>
                  <p class="mb-0 subtext">o arrastre y suelte su archivo aquí</p>
                  <p class="mb-0">Formatos soportados: CSV, Excel.</p>
                </template>
                <template v-else>
                  <p class="mb-0"><strong>{{ file.name }}</strong></p>
                </template>
              </div>

              <v-file-input ref="fileInput" v-model="file" accept=".csv,.xlsx,.xls"
                class="d-none"></v-file-input>
            </v-col>
            <v-col cols="12" md="10">
              <div v-if="error" class=" mb-4 card-error d-flex">
                <font-awesome-icon :icon="['fas', 'triangle-exclamation']" class="mt-1 me-2" />
                <div>

                  <strong>Archivo requerido</strong><br />
                  Debe cargar un archivo para iniciar el proceso.
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="10" class="text-end">
              <v-btn color="primary" @click="processFiles">Procesar</v-btn>

            </v-col>
          </v-row>
        </v-card>
        <DialogLoading :dialog="loading_process" text="Procesando..." />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { signingService } from "@/libs/ws/signingService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogLoading from "@/components/DialogLoading.vue";

export default {
  components: { Title, DialogLoading },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      page_title: "Fichajes",
      loading_process: false,
      file: null,
      error: false,
    };
  },
  methods: {
    resetForm() {
      this.file = null;
      this.error = false;
    },
    triggerFile() {
      this.$refs.fileInput.$el.querySelector('input').click();
    },
    processFiles() {
      if (this.loading_process) return;

      // Validar archivos
      if (!this.file) {
        this.error = true;
        return;
      }

      this.error = false;
      this.loading_process = true;

      const formData = new FormData();
      formData.append("file_signings", this.file);

      signingService
        .process_files(formData)
        .then((response) => {
          try {
            // Intentamos interpretar la respuesta como texto
            const text = new TextDecoder().decode(response);
            const json = JSON.parse(text);

            // Si llega acá, es un JSON de error
            this.$toast.error(json.msg || "Error desconocido", "Error");
            this.loading_process = false;
            this.file = null;
            this.mayor = null;
          } catch (e) {
            // No era JSON: asumimos que es el Excel
            const blob = new Blob([response], {
              type: "application/vnd.ms-excel",
            });
            const link = document.createElement("a");
            link.download = "fichajes.xlsx";
            link.href = window.URL.createObjectURL(blob);
            link.target = "_blank";
            link.click();
            this.loading_process = false;
          }
        })
        .catch((e) => {
          console.error("service.export_filter error", e);
          this.$toast.error("Ha ocurrido un error", "Error");
          this.loading_process = false;
        });
    }

  },
};
</script>
